import { useContext } from 'react'
import { ErrorNotificationsContext } from 'src/contexts/ErrorNotificationsContext'
import Notification from './Notification'

const ErrorNotifications = () => {
    const { errors } = useContext(ErrorNotificationsContext)

    if (errors.length === 0) {
        return
    }

    return (
        <div data-testid="error-notifications-wrapper">
            <Notification
                message={errors[errors.length - 1].message}
                description={errors[errors.length - 1].description}
            />
        </div>
    )
}

export default ErrorNotifications
